import { render, staticRenderFns } from "./PrivacyNoticeModal.vue?vue&type=template&id=1bdd7ad0&scoped=true&"
import script from "./PrivacyNoticeModal.vue?vue&type=script&lang=js&"
export * from "./PrivacyNoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyNoticeModal.vue?vue&type=style&index=0&id=1bdd7ad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdd7ad0",
  null
  
)

export default component.exports